import useRecoverPasswordPage from './useRecoverPasswordPage';
import { RECOVER_PASSWORD_STEPS } from '../../../utils/enums';
import RecoverMethodView from '../../../components/platform/auth/RecoverMethodView';
import CellphoneView from '../../../components/platform/auth/CellphoneView';
import EmailView from '../../../components/platform/auth/EmailView';
import VerificationCodeView from '../../../components/platform/auth/VerificationCodeView';
import PasswordView from '../../../components/platform/auth/PasswordView';
import SuccessView from '../../../components/platform/auth/SuccessView';
import { Container, Stack } from '@mui/material';


const RecoverPasswordPage = () => {

    const {system, 
        method,
        view, code, 
        onSelectedMethod,
        onRequestVerificationEmailCode,
        onRequestVerificationMobileCode,
        onRequestVerificationCode,
        onConfirmCode,
        form, onChangeForm,
        onSubmit,
        onGoToLogin, 
        onCloseError,
        onUpdatePhoneCode,
        onChangeRegistrationMethod,
        onGoBack,
    } = useRecoverPasswordPage()

    let contentView = null


    switch (view) {
        case RECOVER_PASSWORD_STEPS.SELECT_METHOD:
            contentView = <RecoverMethodView 
                //disabled_email={true}
                onSelectedMethod={onSelectedMethod}
            />
            break;
        case RECOVER_PASSWORD_STEPS.CELLPHONE:
            contentView= <CellphoneView 
                loading={system.sending}
                error={system.error}
                stepper={{position:0, steps:4}}
                mobileForm={form?.mobile}
                mobileCountryForm={form?.mobile_country_id}
                onChange={onChangeForm}
                onRequestVerificationCode={onRequestVerificationMobileCode}
                onCloseError={onCloseError}
                onReturn={onGoBack}
                />
            break;
        case RECOVER_PASSWORD_STEPS.EMAIL:
            contentView= <EmailView
                loading={system.sending}
                error={system.error}
                stepper={{position:0, steps:4}}
                emailForm={form.email}
                onChange={onChangeForm}
                onRequestVerificationCode={onRequestVerificationEmailCode}
                onCloseError={onCloseError}
                onReturn={onGoBack}
            />
            break;
        case RECOVER_PASSWORD_STEPS.VERIFICATION_CODE:
            contentView = 
            <VerificationCodeView
                method={method}
                loading={system.sending}
                error={system.error}
                stepper={{position:1, steps:4}}
                code={code}
                email={form?.email?.value}
                mobile={form?.mobile?.value}
                mobileCountry={form?.mobile_country_id?.value}
                onUpdatePhoneCode={onUpdatePhoneCode}
                onConfirmCode={onConfirmCode}
                onRequestVerificationCode={onRequestVerificationCode}
                onChangeRegistrationMethod={onChangeRegistrationMethod}
                onCloseError={onCloseError} 
                onReturn={onGoBack}
            />
            break;
        case RECOVER_PASSWORD_STEPS.PASSWORD:
            contentView = 
            <PasswordView
                loading={system.sending}
                error={system.error}
                stepper={{position:3, steps:4}}
                passwordForm={form.password}
                passwordConfirmationForm={form.passwordConfirmation}
                onChange={onChangeForm}
                onCloseError={onCloseError} 
                onSubmit={onSubmit}
                onReturn={onGoBack}
            />
            break;
        case RECOVER_PASSWORD_STEPS.SUCCESS:
                contentView = <SuccessView
                    loading={system.sending}
                    onSubmit={onGoToLogin}
                    onReturn={onGoBack}
                />
                break;
        default:
            break;
    }
    


    return ( 
        <Container >
            <Stack sx={{
                py: 12,
                m: 'auto',
                maxWidth: 400,
                minHeight: '100vh',
                textAlign: 'center',
                justifyContent: 'center',
            }}>
                {contentView}
            </Stack>
            
        </Container>
     );
}

 
export default RecoverPasswordPage;



